import { entityScripts } from "@/lib/entityJsonLd";
import { createFileRoute } from "@tanstack/react-router";
import MarketHub from "@/pages/MarketHub";
import { MainLayout } from "@/components/layout/MainLayout";
import { socialMeta, readable } from "@/lib/routeSocial";
import { findMarketCluster } from "@/lib/seoClusters";

export const Route = createFileRoute("/markets/$slug")({
  head: ({ params }) => {
    const cluster = findMarketCluster(params.slug);
    const label = cluster?.label ?? `${readable(params.slug)} Predictions`;
    return {
      scripts: entityScripts({ type: "Thing", name: label, path: `/markets/${params.slug}`, crumbs: [{ name: "Markets", path: "/markets" }, { name: label, path: `/markets/${params.slug}` }], extra: {} }),
      meta: socialMeta({
        seo: { topics: [params.slug, "footballPredictions"] },
        title: cluster?.title ?? `${label} & Betting Tips | Statlign`,
        description:
          cluster?.description ??
          `${label} from the Statlign 50-strategy engine, with odds, confidence and the reasoning behind every selection.`,
      }),
    };
  },
  component: () => (
    <MainLayout>
      <MarketHub />
    </MainLayout>
  ),
});
